import { hooks } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const trackSiteSaveCompleted = () => {
  hooks.operations.subscribe(hooks.availableHooks.ON_AFTER_SITE_SAVE, () => {
    trackEvent(constants.events.SITE_SAVE_COMPLETED);
  });
};

export default trackSiteSaveCompleted;
